import Vue from 'vue'
import { formatISO } from 'date-fns'

Vue.filter('formatDateIsoStart', (value) => {
  if (value) {
    const tempVal = value.split('-')

    if (tempVal.length === 3) {

      const temp = formatISO(new Date(tempVal[0], Number(tempVal[1]) - 1, tempVal[2], 0, 0, 0)).split('+')

      return `${temp[0]}.000+${temp[1]}`
    }
  }

  return ''
})
